import { render } from "./NavBar.vue?vue&type=template&id=b78795e2&scoped=true"
const script = {}

import "./NavBar.vue?vue&type=style&index=0&id=b78795e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b78795e2"]])

export default __exports__